import React, { useEffect } from "react";
import { Header } from "../../internal/Header/Header";
import Footer from "../NewLandingPage/components/Footer";
import { Helmet } from "react-helmet";
import { Hero } from "../Resources/Webinar";
import { Images } from "../../../assets/images";
import {
  PageContainer,
  ContentSection,
  ClauseCard,
  ClauseList,
  ClausePoint,
  HeroTitle,
} from "../Resources/ModelClauses";
import { HyperLink } from "../../common/FormInputs";

function NegotiationClauseRules(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const clauses = [
    {
      title: "IAMC Model Negotiation Clause",
      points: [
        <>
          The parties shall endeavour to resolve any dispute arising out of or
          in connection with anything contained in the Agreement or otherwise by{" "}
          <HyperLink
            onClick={() =>
              window.open(`https://user.iamch.org.in/negotiation-model-clause`)
            }
          >
            negotiation
          </HyperLink>{" "}
          through IAMC [www.iamch.org.in] within 30 (thirty days) of its
          occurrence or such extended time as may be mutually agreed by the
          parties.
        </>,
        "The Institution shall, among other things, appoint a neutral Mediator/Conciliator and provide a platform for settlement of dispute between the parties as per the negotiation Rules of the Institution. The settlement agreement resulting from the negotiation shall be provided in the form of a Conciliation Award as per section 74 of the Arbitration and Conciliation Act, 1996.",
        "Should this clause create a contradiction with a statutory requirement or a judicial mandate to resolve certain types of disputes through specific courts, the statutory requirement shall prevail.",
      ],
    },
  ];

  return (
    <>
      <Helmet>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <title>Model Dispute Resolution Clause - Negotiation - IAMC</title>
        <meta
          name="description"
          content="Learn about IAMC Negotiation Model Clause."
        />
        <meta
          name="keywords"
          content="Negotiation Model Clause Rules, Negotiation Mediation and Arbitration, Negotiation Dispute Resolution, Negotiation Rules, Online Dispute Resolution, Alternative Dispute Resolution, IAMC"
        />
      </Helmet>
      <div>
        <Header>
          <PageContainer>
            <Hero bgImage={Images.modalClause}>
              <HeroTitle>Negotiation Model Clause</HeroTitle>
            </Hero>

            <ContentSection>
              {clauses.map((clause, index) => (
                <ClauseCard key={index}>
                  <ClauseList>
                    {clause.points.map((point, pointIndex) => (
                      <ClausePoint key={pointIndex}>{point}</ClausePoint>
                    ))}
                  </ClauseList>
                </ClauseCard>
              ))}
            </ContentSection>
          </PageContainer>
        </Header>
        <Footer />
      </div>
    </>
  );
}

export default NegotiationClauseRules;
